if (process.env.NODE_ENV === 'production') {
  // Temp disable sentry
  // module.exports = window.Raven
  module.exports = require('./raven.development.js')
} else {
  module.exports = require('./raven.development.js')
}



// WEBPACK FOOTER //
// ./src/lib/raven.js